/**
 * Video Codecs Support
 * 全局视频 codecs 支持工具
 * 自动为所有 video 标签添加 codecs 支持
 */

(function() {
  'use strict';

  // 防止重复初始化
  if (window.videoCodecsSupportInitialized) return;
  window.videoCodecsSupportInitialized = true;

  /**
   * 为单个 source 元素添加 codecs 支持
   */
  function enhanceSourceElement(source) {
    var type = source.getAttribute('type') || '';
    var src = source.getAttribute('src') || source.src;
    
    if (!src) return;

    // 如果已经有 codecs，跳过
    if (type.indexOf('codecs=') !== -1) return;

    // 处理 MP4
    if (type.indexOf('video/mp4') !== -1 || type === 'video/mp4') {
      // 检查是否已经有带 codecs 的 source（避免重复）
      var video = source.parentElement;
      if (video && video.tagName === 'VIDEO') {
        var existingCodecsSource = Array.from(video.querySelectorAll('source')).find(function(s) {
          var t = s.getAttribute('type') || '';
          return t.indexOf('codecs=avc1.42E01E') !== -1 && s.src === src;
        });
        
        if (!existingCodecsSource) {
          // 创建带 codecs 的 source，插入到当前 source 之前
          var codecsSource = document.createElement('source');
          codecsSource.src = src;
          codecsSource.type = 'video/mp4; codecs=avc1.42E01E,mp4a.40.2';
          // 复制所有 data 属性
          Array.from(source.attributes).forEach(function(attr) {
            if (attr.name.startsWith('data-')) {
              codecsSource.setAttribute(attr.name, attr.value);
            }
          });
          source.parentElement.insertBefore(codecsSource, source);
        }
      }
    }
  }

  /**
   * 为所有 video 标签添加 codecs 支持
   */
  function enhanceAllVideos() {
    var videos = document.querySelectorAll('video');
    videos.forEach(function(video) {
      var sources = video.querySelectorAll('source');
      sources.forEach(function(source) {
        enhanceSourceElement(source);
      });
    });
  }

  /**
   * 创建带 codecs 支持的 source 元素
   * @param {string} src - 视频 URL
   * @param {string} type - 视频类型 ('mp4' 或 'webm')
   * @param {string} codecs - codecs 类型 ('h264' 或 'hevc')
   * @param {object} attributes - 额外的属性对象
   * @returns {Array} source 元素数组
   */
  window.createVideoSources = function(src, type, codecs, attributes) {
    type = type || 'mp4';
    codecs = codecs || 'h264';
    attributes = attributes || {};
    
    var sources = [];
    
    if (type === 'mp4') {
      if (codecs === 'hevc') {
        // HEVC source
        var hevcSource = document.createElement('source');
        hevcSource.src = src;
        hevcSource.type = 'video/mp4; codecs=hevc';
        Object.keys(attributes).forEach(function(key) {
          hevcSource.setAttribute(key, attributes[key]);
        });
        sources.push(hevcSource);
      }
      
      // H.264 source with codecs
      var h264Source = document.createElement('source');
      h264Source.src = src;
      h264Source.type = 'video/mp4; codecs=avc1.42E01E,mp4a.40.2';
      Object.keys(attributes).forEach(function(key) {
        h264Source.setAttribute(key, attributes[key]);
      });
      sources.push(h264Source);
      
      // Fallback source without codecs
      var fallbackSource = document.createElement('source');
      fallbackSource.src = src;
      fallbackSource.type = 'video/mp4';
      Object.keys(attributes).forEach(function(key) {
        fallbackSource.setAttribute(key, attributes[key]);
      });
      sources.push(fallbackSource);
    } else if (type === 'webm') {
      var webmSource = document.createElement('source');
      webmSource.src = src;
      webmSource.type = 'video/webm';
      Object.keys(attributes).forEach(function(key) {
        webmSource.setAttribute(key, attributes[key]);
      });
      sources.push(webmSource);
    }
    
    return sources;
  };

  // 初始化：为现有视频添加支持
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAllVideos);
  } else {
    enhanceAllVideos();
  }

  // 监听新添加的视频（MutationObserver）
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'VIDEO') {
              var sources = node.querySelectorAll('source');
              sources.forEach(function(source) {
                enhanceSourceElement(source);
              });
            } else if (node.tagName === 'SOURCE') {
              enhanceSourceElement(node);
            } else {
              // 检查子元素
              var videos = node.querySelectorAll && node.querySelectorAll('video');
              if (videos) {
                videos.forEach(function(video) {
                  var sources = video.querySelectorAll('source');
                  sources.forEach(function(source) {
                    enhanceSourceElement(source);
                  });
                });
              }
            }
          }
        });
      });
    });

    // 确保 document.body 存在后再观察
    function startObserving() {
      if (document.body && document.body.nodeType === 1) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      } else {
        // 如果 body 还不存在，等待 DOMContentLoaded
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', startObserving);
        } else {
          // 如果已经加载完成但 body 仍不存在，延迟重试
          setTimeout(startObserving, 100);
        }
      }
    }

    startObserving();
  }

  // Shopify section load 事件
  document.addEventListener('shopify:section:load', function() {
    setTimeout(enhanceAllVideos, 100);
  });
})();

